import React from 'react';

export const IBU = () => {
  return (
    <svg width="87" height="88" viewBox="0 0 87 88" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.80356e-06 43.9923C5.90415e-06 19.9643 19.4797 0.499994 43.4923 0.499996C67.5203 0.499998 87 19.9644 87 43.9923C87 68.0203 67.5203 87.5 43.4923 87.5C19.4797 87.5 1.70297e-06 68.0203 3.80356e-06 43.9923ZM3.00158 43.9923C3.00158 66.3664 21.1336 84.4984 43.4923 84.4984C65.8664 84.4984 83.9984 66.3664 83.9984 43.9923C83.9984 21.6336 65.8664 3.50158 43.4923 3.50158C21.1336 3.50157 3.00159 21.6336 3.00158 43.9923Z"
        fill="url(#paint0_radial_14427_90654)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.82032 44.0065C1.82032 20.8135 20.6197 2.01415 43.8127 2.01416C67.021 2.01416 85.8203 20.8135 85.8203 44.0065C85.8203 67.2148 67.021 86.0142 43.8127 86.0142C20.6197 86.0142 1.82031 67.2148 1.82032 44.0065ZM3.33589 44.0065C3.33589 66.3728 21.4616 84.4986 43.8127 84.4986C66.179 84.4986 84.3047 66.3728 84.3047 44.0065C84.3047 21.6555 66.179 3.52972 43.8127 3.52972C21.4617 3.52972 3.33589 21.6555 3.33589 44.0065Z"
        fill="url(#paint1_linear_14427_90654)"
      />
      <path
        d="M43.8006 3.50132C66.1746 3.50132 84.3066 21.6333 84.3066 43.9921C84.3066 66.3661 66.1746 84.4982 43.8006 84.4982C21.4418 84.4982 3.30979 66.3661 3.3098 43.9921C3.3098 21.6333 21.4418 3.50131 43.8006 3.50132Z"
        fill="url(#paint2_radial_14427_90654)"
      />
      <path
        style={{mixBlendMode: 'screen'}}
        d="M43.0167 9.13702C61.4856 9.13702 76.4629 24.1143 76.4629 42.5986C76.4629 61.0675 61.4856 76.0448 43.0167 76.0448C24.5324 76.0448 9.55512 61.0675 9.55513 42.5986C9.55513 24.1143 24.5324 9.13702 43.0167 9.13702Z"
        fill="url(#paint3_radial_14427_90654)"
      />
      <path
        style={{mixBlendMode: 'screen'}}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.7343 20.6837C29.8479 6.71711 50.9662 5.21632 64.9327 17.3299C78.884 29.4281 80.3848 50.5464 68.2865 64.5129C56.173 78.4642 35.0547 79.965 21.1035 67.8667C7.13691 55.7532 5.63612 34.6349 17.7343 20.6837ZM17.4587 21.6944C6.72343 34.0836 8.05577 52.8435 20.445 63.5941C32.8342 74.3447 51.5941 73.0123 62.3446 60.6231C73.0952 48.2186 71.7629 29.4587 59.3584 18.7235C46.9692 7.97288 28.2093 9.30521 17.4587 21.6944Z"
        fill="url(#paint4_radial_14427_90654)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.30469 43.4903C2.30469 20.8546 20.6613 2.49804 43.2969 2.49804C65.9481 2.49805 84.3047 20.8546 84.3047 43.4903C84.3047 66.1415 65.9481 84.498 43.2969 84.498C20.6613 84.498 2.30469 66.1415 2.30469 43.4903ZM5.38996 45.8314C7.07988 64.467 21.4675 81.8934 40.1807 81.8934C47.1884 81.8934 49.7465 71.9864 57.7621 71.7849C75.359 71.3353 81.9481 56.2035 81.9481 44.5135C81.9481 25.8159 61.669 28.25 46.3357 8.45153C34.8783 -6.32367 3.18841 21.6453 5.38996 45.8314Z"
        fill="url(#paint5_radial_14427_90654)"
      />
      <path
        style={{mixBlendMode: 'screen'}}
        d="M65.7884 14.5737C67.8405 14.5737 69.5098 16.243 69.5098 18.2951C69.5098 20.3319 67.8405 22.0011 65.7884 22.0011C63.7363 22.0011 62.0824 20.3319 62.0824 18.2951C62.0824 16.243 63.7363 14.5737 65.7884 14.5737Z"
        fill="url(#paint6_radial_14427_90654)"
      />
      <path
        d="M62.3081 18.295C62.3081 16.3655 63.8701 14.8187 65.7844 14.8187C67.714 14.8187 69.2607 16.3655 69.2607 18.295C69.2607 20.2093 67.714 21.7714 65.7844 21.7714C63.8701 21.7714 62.3081 20.2093 62.3081 18.295Z"
        fill="url(#paint7_radial_14427_90654)"
      />
      <path
        style={{mixBlendMode: 'screen'}}
        opacity="0.5"
        d="M63.3562 18.2643C63.3562 16.7941 64.5507 15.6149 66.0209 15.6149C67.491 15.6149 68.6855 16.7941 68.6855 18.2643C68.6855 19.7345 67.491 20.929 66.0209 20.929C64.5507 20.929 63.3562 19.7345 63.3562 18.2643Z"
        fill="url(#paint8_radial_14427_90654)"
      />
      <path
        style={{mixBlendMode: 'screen'}}
        d="M65.4079 19.6119C65.4079 18.8922 66.0052 18.2949 66.725 18.2949C67.4447 18.2949 68.042 18.8922 68.042 19.6119C68.042 20.347 67.4447 20.929 66.725 20.929C66.0052 20.929 65.4079 20.347 65.4079 19.6119Z"
        fill="url(#paint9_radial_14427_90654)"
      />
      <path
        style={{mixBlendMode: 'screen'}}
        d="M70.4444 67.0247C71.7002 67.0247 72.7109 68.0507 72.7109 69.2912C72.7109 70.5316 71.7002 71.5424 70.4444 71.5424C69.204 71.5424 68.1932 70.5316 68.1932 69.2912C68.1932 68.0507 69.204 67.0247 70.4444 67.0247Z"
        fill="url(#paint10_radial_14427_90654)"
      />
      <path
        d="M68.3319 69.2912C68.3319 68.1273 69.2814 67.1778 70.4452 67.1778C71.6091 67.1778 72.5586 68.1273 72.5586 69.2912C72.5586 70.4551 71.6091 71.4045 70.4452 71.4045C69.2814 71.4045 68.3319 70.4551 68.3319 69.2912Z"
        fill="url(#paint11_radial_14427_90654)"
      />
      <path
        style={{mixBlendMode: 'screen'}}
        opacity="0.5"
        d="M68.9748 69.2759C68.9748 68.3876 69.6945 67.6679 70.5827 67.6679C71.471 67.6679 72.2061 68.3876 72.2061 69.2759C72.2061 70.1641 71.471 70.8992 70.5827 70.8992C69.6945 70.8992 68.9748 70.1641 68.9748 69.2759Z"
        fill="url(#paint12_radial_14427_90654)"
      />
      <path
        style={{mixBlendMode: 'screen'}}
        d="M70.211 70.0875C70.211 69.6587 70.5633 69.2912 71.0074 69.2912C71.4515 69.2912 71.8037 69.6587 71.8037 70.0875C71.8037 70.5316 71.4515 70.8992 71.0074 70.8992C70.5633 70.8992 70.211 70.5316 70.211 70.0875Z"
        fill="url(#paint13_radial_14427_90654)"
      />
      <g style={{mixBlendMode: 'screen'}}>
        <path
          d="M58.4036 12.1695C59.3684 12.1695 60.1494 12.9505 60.1494 13.9153C60.1494 14.8801 59.3684 15.6611 58.4036 15.6611C57.4541 15.6611 56.6578 14.8801 56.6578 13.9153C56.6578 12.9505 57.4541 12.1695 58.4036 12.1695Z"
          fill="url(#paint14_radial_14427_90654)"
        />
      </g>
      <path
        d="M56.7771 13.9152C56.7771 13.0117 57.4969 12.2766 58.4004 12.2766C59.304 12.2766 60.0391 13.0117 60.0391 13.9152C60.0391 14.8187 59.304 15.5538 58.4004 15.5538C57.4969 15.5538 56.7771 14.8187 56.7771 13.9152Z"
        fill="url(#paint15_radial_14427_90654)"
      />
      <path
        style={{mixBlendMode: 'screen'}}
        opacity="0.5"
        d="M57.2723 13.9C57.2723 13.2109 57.8237 12.6595 58.5128 12.6595C59.2019 12.6595 59.7686 13.2109 59.7686 13.9C59.7686 14.6044 59.2019 15.1558 58.5128 15.1558C57.8237 15.1558 57.2723 14.6044 57.2723 13.9Z"
        fill="url(#paint16_radial_14427_90654)"
      />
      <path
        style={{mixBlendMode: 'screen'}}
        d="M58.2319 14.5432C58.2319 14.2063 58.5076 13.9153 58.8445 13.9153C59.1814 13.9153 59.457 14.2063 59.457 14.5432C59.457 14.8801 59.1814 15.1558 58.8445 15.1558C58.5076 15.1558 58.2319 14.8801 58.2319 14.5432Z"
        fill="url(#paint17_radial_14427_90654)"
      />
      <path
        style={{mixBlendMode: 'screen'}}
        d="M81.6109 36.3501C82.392 36.3501 83.0352 36.978 83.0352 37.759C83.0352 38.5553 82.392 39.1832 81.6109 39.1832C80.8299 39.1832 80.1867 38.5553 80.1867 37.759C80.1867 36.978 80.8299 36.3501 81.6109 36.3501Z"
        fill="url(#paint18_radial_14427_90654)"
      />
      <path
        d="M80.2738 37.7592C80.2738 37.0241 80.8711 36.4422 81.6061 36.4422C82.3412 36.4422 82.9385 37.0241 82.9385 37.7592C82.9385 38.4943 82.3412 39.0916 81.6061 39.0916C80.8711 39.0916 80.2738 38.4943 80.2738 37.7592Z"
        fill="url(#paint19_radial_14427_90654)"
      />
      <path
        style={{mixBlendMode: 'screen'}}
        opacity="0.5"
        d="M80.68 37.7588C80.68 37.1922 81.1394 36.7327 81.6907 36.7327C82.2574 36.7327 82.7168 37.1922 82.7168 37.7588C82.7168 38.3101 82.2574 38.7695 81.6907 38.7695C81.1394 38.7695 80.68 38.3101 80.68 37.7588Z"
        fill="url(#paint20_radial_14427_90654)"
      />
      <path
        style={{mixBlendMode: 'screen'}}
        d="M81.457 38.2642C81.457 37.9885 81.6867 37.7741 81.9624 37.7741C82.2381 37.7741 82.4678 37.9885 82.4678 38.2642C82.4678 38.5551 82.2381 38.7695 81.9624 38.7695C81.6867 38.7695 81.457 38.5551 81.457 38.2642Z"
        fill="url(#paint21_radial_14427_90654)"
      />
      <path
        style={{mixBlendMode: 'screen'}}
        d="M67.5431 72.4759C68.0178 72.4759 68.416 72.874 68.416 73.3488C68.416 73.8388 68.0178 74.2217 67.5431 74.2217C67.0531 74.2217 66.6702 73.8388 66.6702 73.3488C66.6702 72.874 67.0531 72.4759 67.5431 72.4759Z"
        fill="url(#paint22_radial_14427_90654)"
      />
      <path
        d="M66.7149 73.3488C66.7149 72.9047 67.0824 72.5372 67.5419 72.5372C67.986 72.5372 68.3535 72.9047 68.3535 73.3488C68.3535 73.8082 67.986 74.1758 67.5419 74.1758C67.0824 74.1758 66.7149 73.8082 66.7149 73.3488Z"
        fill="url(#paint23_radial_14427_90654)"
      />
      <path
        style={{mixBlendMode: 'screen'}}
        opacity="0.5"
        d="M66.9591 73.3489C66.9591 72.9967 67.2347 72.721 67.587 72.721C67.9392 72.721 68.2148 72.9967 68.2148 73.3489C68.2148 73.6858 67.9392 73.9768 67.587 73.9768C67.2347 73.9768 66.9591 73.6858 66.9591 73.3489Z"
        fill="url(#paint24_radial_14427_90654)"
      />
      <path
        style={{mixBlendMode: 'screen'}}
        d="M67.4499 73.6705C67.4499 73.4868 67.5878 73.3489 67.7562 73.3489C67.9247 73.3489 68.0625 73.4868 68.0625 73.6705C68.0625 73.839 67.9247 73.9768 67.7562 73.9768C67.5878 73.9768 67.4499 73.839 67.4499 73.6705Z"
        fill="url(#paint25_radial_14427_90654)"
      />
      <g style={{mixBlendMode: 'screen'}}>
        <path
          d="M55.6565 73.9927C56.6213 73.9927 57.4023 74.7738 57.4023 75.7386C57.4023 76.7034 56.6213 77.4844 55.6565 77.4844C54.6917 77.4844 53.9107 76.7034 53.9107 75.7386C53.9107 74.7738 54.6917 73.9927 55.6565 73.9927Z"
          fill="url(#paint26_radial_14427_90654)"
        />
      </g>
      <path
        d="M54.0148 75.7386C54.0148 74.8351 54.7498 74.1 55.6534 74.1C56.5569 74.1 57.292 74.8351 57.292 75.7386C57.292 76.6422 56.5569 77.3619 55.6534 77.3619C54.7498 77.3619 54.0148 76.6422 54.0148 75.7386Z"
        fill="url(#paint27_radial_14427_90654)"
      />
      <path
        style={{mixBlendMode: 'screen'}}
        opacity="0.5"
        d="M54.5116 75.7232C54.5116 75.0341 55.0782 74.4828 55.7674 74.4828C56.4565 74.4828 57.0078 75.0341 57.0078 75.7232C57.0078 76.4124 56.4565 76.979 55.7674 76.979C55.0782 76.979 54.5116 76.4124 54.5116 75.7232Z"
        fill="url(#paint28_radial_14427_90654)"
      />
      <path
        style={{mixBlendMode: 'screen'}}
        d="M55.4695 76.3511C55.4695 76.0142 55.7452 75.7386 56.0821 75.7386C56.4343 75.7386 56.71 76.0142 56.71 76.3511C56.71 76.7033 56.4343 76.979 56.0821 76.979C55.7452 76.979 55.4695 76.7033 55.4695 76.3511Z"
        fill="url(#paint29_radial_14427_90654)"
      />
      <path
        style={{mixBlendMode: 'screen'}}
        d="M79.4124 31.0212C80.1934 31.0212 80.8213 31.6491 80.8213 32.4148C80.8213 33.1958 80.1934 33.8237 79.4124 33.8237C78.6467 33.8237 78.0188 33.1958 78.0188 32.4148C78.0188 31.6491 78.6467 31.0212 79.4124 31.0212Z"
        fill="url(#paint30_radial_14427_90654)"
      />
      <path
        d="M78.1059 32.415C78.1059 31.6953 78.6878 31.1133 79.4076 31.1133C80.1427 31.1133 80.7246 31.6953 80.7246 32.415C80.7246 33.1501 80.1427 33.7321 79.4076 33.7321C78.6878 33.7321 78.1059 33.1501 78.1059 32.415Z"
        fill="url(#paint31_radial_14427_90654)"
      />
      <path
        style={{mixBlendMode: 'screen'}}
        opacity="0.5"
        d="M78.4883 32.4149C78.4883 31.8636 78.9477 31.4042 79.499 31.4042C80.0503 31.4042 80.5098 31.8636 80.5098 32.4149C80.5098 32.9662 80.0503 33.4257 79.499 33.4257C78.9477 33.4257 78.4883 32.9662 78.4883 32.4149Z"
        fill="url(#paint32_radial_14427_90654)"
      />
      <path
        style={{mixBlendMode: 'screen'}}
        d="M79.279 32.9203C79.279 32.6446 79.4934 32.4302 79.769 32.4302C80.0447 32.4302 80.2744 32.6446 80.2744 32.9203C80.2744 33.1959 80.0447 33.4257 79.769 33.4257C79.4934 33.4257 79.279 33.1959 79.279 32.9203Z"
        fill="url(#paint33_radial_14427_90654)"
      />
      <path
        style={{mixBlendMode: 'screen'}}
        d="M73.52 23.4098C74.01 23.4098 74.4082 23.8079 74.4082 24.2827C74.4082 24.7727 74.01 25.1709 73.52 25.1709C73.0452 25.1709 72.6471 24.7727 72.6471 24.2827C72.6471 23.8079 73.0452 23.4098 73.52 23.4098Z"
        fill="url(#paint34_radial_14427_90654)"
      />
      <path
        d="M72.7071 24.2829C72.7071 23.8388 73.0746 23.4712 73.5187 23.4712C73.9782 23.4712 74.3457 23.8388 74.3457 24.2829C74.3457 24.7423 73.9782 25.1099 73.5187 25.1099C73.0746 25.1099 72.7071 24.7423 72.7071 24.2829Z"
        fill="url(#paint35_radial_14427_90654)"
      />
      <path
        style={{mixBlendMode: 'screen'}}
        opacity="0.5"
        d="M72.9513 24.2825C72.9513 23.9303 73.2269 23.6546 73.5791 23.6546C73.9161 23.6546 74.207 23.9303 74.207 24.2825C74.207 24.6347 73.9161 24.9104 73.5791 24.9104C73.2269 24.9104 72.9513 24.6347 72.9513 24.2825Z"
        fill="url(#paint36_radial_14427_90654)"
      />
      <path
        style={{mixBlendMode: 'screen'}}
        d="M73.4268 24.6041C73.4268 24.4357 73.5799 24.2978 73.7484 24.2978C73.9169 24.2978 74.0547 24.4357 74.0547 24.6041C74.0547 24.7726 73.9169 24.9104 73.7484 24.9104C73.5799 24.9104 73.4268 24.7726 73.4268 24.6041Z"
        fill="url(#paint37_radial_14427_90654)"
      />
      <path
        style={{mixBlendMode: 'screen'}}
        d="M69.0993 24.6348C69.6506 24.6348 70.0947 25.0789 70.0947 25.6302C70.0947 26.1662 69.6506 26.6256 69.0993 26.6256C68.548 26.6256 68.1039 26.1662 68.1039 25.6302C68.1039 25.0789 68.548 24.6348 69.0993 24.6348Z"
        fill="url(#paint38_radial_14427_90654)"
      />
      <path
        d="M68.1639 25.6302C68.1639 25.1095 68.5774 24.6961 69.0981 24.6961C69.6034 24.6961 70.0322 25.1095 70.0322 25.6302C70.0322 26.1356 69.6034 26.5491 69.0981 26.5491C68.5774 26.5491 68.1639 26.1356 68.1639 25.6302Z"
        fill="url(#paint39_radial_14427_90654)"
      />
      <path
        style={{mixBlendMode: 'screen'}}
        opacity="0.5"
        d="M68.442 25.6151C68.442 25.2169 68.7636 24.9106 69.1618 24.9106C69.5446 24.9106 69.8662 25.2169 69.8662 25.6151C69.8662 26.0132 69.5446 26.3348 69.1618 26.3348C68.7636 26.3348 68.442 26.0132 68.442 25.6151Z"
        fill="url(#paint40_radial_14427_90654)"
      />
      <path
        style={{mixBlendMode: 'screen'}}
        d="M68.9957 25.9826C68.9957 25.7835 69.1489 25.6304 69.348 25.6304C69.5471 25.6304 69.7002 25.7835 69.7002 25.9826C69.7002 26.1664 69.5471 26.3348 69.348 26.3348C69.1489 26.3348 68.9957 26.1664 68.9957 25.9826Z"
        fill="url(#paint41_radial_14427_90654)"
      />
      <path
        style={{mixBlendMode: 'screen'}}
        d="M52.6659 7.59041C53.0947 7.59041 53.4316 7.92732 53.4316 8.35612C53.4316 8.7696 53.0947 9.12183 52.6659 9.12183C52.2524 9.12183 51.9002 8.7696 51.9002 8.35612C51.9002 7.92732 52.2524 7.59041 52.6659 7.59041Z"
        fill="url(#paint42_radial_14427_90654)"
      />
      <path
        d="M51.9586 8.35634C51.9586 7.95817 52.2802 7.63657 52.663 7.63657C53.0612 7.63657 53.3828 7.95817 53.3828 8.35634C53.3828 8.75451 53.0612 9.06079 52.663 9.06079C52.2802 9.06079 51.9586 8.75451 51.9586 8.35634Z"
        fill="url(#paint43_radial_14427_90654)"
      />
      <path
        style={{mixBlendMode: 'screen'}}
        opacity="0.5"
        d="M52.1783 8.34078C52.1783 8.04981 52.4233 7.80478 52.7143 7.80478C53.0206 7.80478 53.2656 8.04981 53.2656 8.34078C53.2656 8.64707 53.0206 8.89209 52.7143 8.89209C52.4233 8.89209 52.1783 8.64707 52.1783 8.34078Z"
        fill="url(#paint44_radial_14427_90654)"
      />
      <path
        style={{mixBlendMode: 'screen'}}
        d="M52.5893 8.63175C52.5893 8.4786 52.7118 8.35609 52.865 8.35609C53.0181 8.35609 53.1406 8.4786 53.1406 8.63175C53.1406 8.76957 53.0181 8.89209 52.865 8.89209C52.7118 8.89209 52.5893 8.76957 52.5893 8.63175Z"
        fill="url(#paint45_radial_14427_90654)"
      />
      <path
        style={{mixBlendMode: 'screen'}}
        d="M61.1484 73.3496C61.5618 73.3496 61.9141 73.7018 61.9141 74.1153C61.9141 74.5441 61.5618 74.881 61.1484 74.881C60.7196 74.881 60.3826 74.5441 60.3826 74.1153C60.3826 73.7018 60.7196 73.3496 61.1484 73.3496Z"
        fill="url(#paint46_radial_14427_90654)"
      />
      <path
        d="M60.4257 74.1153C60.4257 73.7171 60.7473 73.3955 61.1455 73.3955C61.5436 73.3955 61.8652 73.7171 61.8652 74.1153C61.8652 74.5135 61.5436 74.8351 61.1455 74.8351C60.7473 74.8351 60.4257 74.5135 60.4257 74.1153Z"
        fill="url(#paint47_radial_14427_90654)"
      />
      <path
        style={{mixBlendMode: 'screen'}}
        opacity="0.5"
        d="M60.6454 74.1151C60.6454 73.8088 60.8905 73.5638 61.1967 73.5638C61.4877 73.5638 61.748 73.8088 61.748 74.1151C61.748 74.4214 61.4877 74.6664 61.1967 74.6664C60.8905 74.6664 60.6454 74.4214 60.6454 74.1151Z"
        fill="url(#paint48_radial_14427_90654)"
      />
      <path
        style={{mixBlendMode: 'screen'}}
        d="M61.0665 74.3907C61.0665 74.2376 61.1737 74.1151 61.3269 74.1151C61.48 74.1151 61.6025 74.2376 61.6025 74.3907C61.6025 74.5439 61.48 74.6664 61.3269 74.6664C61.1737 74.6664 61.0665 74.5439 61.0665 74.3907Z"
        fill="url(#paint49_radial_14427_90654)"
      />
      <path
        style={{mixBlendMode: 'screen'}}
        d="M54.2463 79.6129C54.8589 79.6129 55.3643 80.103 55.3643 80.7156C55.3643 81.3281 54.8589 81.8335 54.2463 81.8335C53.6338 81.8335 53.1437 81.3281 53.1437 80.7156C53.1437 80.103 53.6338 79.6129 54.2463 79.6129Z"
        fill="url(#paint50_radial_14427_90654)"
      />
      <path
        d="M53.2054 80.7156C53.2054 80.149 53.6801 79.6742 54.2467 79.6742C54.8287 79.6742 55.2881 80.149 55.2881 80.7156C55.2881 81.2975 54.8287 81.757 54.2467 81.757C53.6801 81.757 53.2054 81.2975 53.2054 80.7156Z"
        fill="url(#paint51_radial_14427_90654)"
      />
      <path
        style={{mixBlendMode: 'screen'}}
        opacity="0.5"
        d="M53.5242 80.7156C53.5242 80.2715 53.8764 79.9193 54.3205 79.9193C54.7493 79.9193 55.1016 80.2715 55.1016 80.7156C55.1016 81.1444 54.7493 81.512 54.3205 81.512C53.8764 81.512 53.5242 81.1444 53.5242 80.7156Z"
        fill="url(#paint52_radial_14427_90654)"
      />
      <path
        style={{mixBlendMode: 'screen'}}
        d="M54.1399 81.1138C54.1399 80.8994 54.3083 80.7156 54.5227 80.7156C54.7371 80.7156 54.9209 80.8994 54.9209 81.1138C54.9209 81.3282 54.7371 81.512 54.5227 81.512C54.3083 81.512 54.1399 81.3282 54.1399 81.1138Z"
        fill="url(#paint53_radial_14427_90654)"
      />
      <path
        style={{mixBlendMode: 'screen'}}
        d="M53.4341 11.9245C53.8935 11.9245 54.2764 12.3074 54.2764 12.7821C54.2764 13.2415 53.8935 13.6244 53.4341 13.6244C52.9593 13.6244 52.5765 13.2415 52.5765 12.7821C52.5765 12.3074 52.9593 11.9245 53.4341 11.9245Z"
        fill="url(#paint54_radial_14427_90654)"
      />
      <path
        d="M52.6195 12.7818C52.6195 12.3377 52.9871 11.9855 53.4312 11.9855C53.86 11.9855 54.2275 12.3377 54.2275 12.7818C54.2275 13.2259 53.86 13.5781 53.4312 13.5781C52.9871 13.5781 52.6195 13.2259 52.6195 12.7818Z"
        fill="url(#paint55_radial_14427_90654)"
      />
      <path
        style={{mixBlendMode: 'screen'}}
        opacity="0.5"
        d="M52.8715 12.7669C52.8715 12.43 53.1472 12.1697 53.4841 12.1697C53.821 12.1697 54.0967 12.43 54.0967 12.7669C54.0967 13.1039 53.821 13.3795 53.4841 13.3795C53.1472 13.3795 52.8715 13.1039 52.8715 12.7669Z"
        fill="url(#paint56_radial_14427_90654)"
      />
      <path
        style={{mixBlendMode: 'screen'}}
        d="M53.3471 13.0886C53.3471 12.9201 53.4849 12.7823 53.6534 12.7823C53.8065 12.7823 53.9443 12.9201 53.9443 13.0886C53.9443 13.257 53.8065 13.3795 53.6534 13.3795C53.4849 13.3795 53.3471 13.257 53.3471 13.0886Z"
        fill="url(#paint57_radial_14427_90654)"
      />
      <path
        style={{mixBlendMode: 'screen'}}
        d="M50.4272 78.939C50.7029 78.939 50.9326 79.1687 50.9326 79.4291C50.9326 79.7047 50.7029 79.9344 50.4272 79.9344C50.1669 79.9344 49.9372 79.7047 49.9372 79.4291C49.9372 79.1687 50.1669 78.939 50.4272 78.939Z"
        fill="url(#paint58_radial_14427_90654)"
      />
      <path
        d="M49.9643 79.4291C49.9643 79.1841 50.1787 78.9697 50.4237 78.9697C50.684 78.9697 50.8984 79.1841 50.8984 79.4291C50.8984 79.6895 50.684 79.8885 50.4237 79.8885C50.1787 79.8885 49.9643 79.6895 49.9643 79.4291Z"
        fill="url(#paint59_radial_14427_90654)"
      />
      <path
        style={{mixBlendMode: 'screen'}}
        opacity="0.5"
        d="M50.11 79.429C50.11 79.2299 50.2785 79.0768 50.4622 79.0768C50.6613 79.0768 50.8145 79.2299 50.8145 79.429C50.8145 79.6281 50.6613 79.7812 50.4622 79.7812C50.2785 79.7812 50.11 79.6281 50.11 79.429Z"
        fill="url(#paint60_radial_14427_90654)"
      />
      <path
        style={{mixBlendMode: 'screen'}}
        d="M50.3792 79.6128C50.3792 79.5209 50.4558 79.429 50.563 79.429C50.6549 79.429 50.7314 79.5209 50.7314 79.6128C50.7314 79.7047 50.6549 79.7812 50.563 79.7812C50.4558 79.7812 50.3792 79.7047 50.3792 79.6128Z"
        fill="url(#paint61_radial_14427_90654)"
      />
      <path
        style={{mixBlendMode: 'screen'}}
        d="M73.9966 20.1477C74.4407 20.1477 74.793 20.5152 74.793 20.9593C74.793 21.4035 74.4407 21.771 73.9966 21.771C73.5525 21.771 73.185 21.4035 73.185 20.9593C73.185 20.5152 73.5525 20.1477 73.9966 20.1477Z"
        fill="url(#paint62_radial_14427_90654)"
      />
      <path
        d="M73.228 20.9592C73.228 20.5457 73.5649 20.1935 73.9937 20.1935C74.4072 20.1935 74.7441 20.5457 74.7441 20.9592C74.7441 21.3727 74.4072 21.7096 73.9937 21.7096C73.5649 21.7096 73.228 21.3727 73.228 20.9592Z"
        fill="url(#paint63_radial_14427_90654)"
      />
      <path
        style={{mixBlendMode: 'screen'}}
        opacity="0.5"
        d="M73.4631 20.9437C73.4631 20.6374 73.7234 20.3771 74.045 20.3771C74.3666 20.3771 74.627 20.6374 74.627 20.9437C74.627 21.2653 74.3666 21.5256 74.045 21.5256C73.7234 21.5256 73.4631 21.2653 73.4631 20.9437Z"
        fill="url(#paint64_radial_14427_90654)"
      />
      <path
        style={{mixBlendMode: 'screen'}}
        d="M73.8995 21.25C73.8995 21.0815 74.0373 20.959 74.1905 20.959C74.3436 20.959 74.4814 21.0815 74.4814 21.25C74.4814 21.4031 74.3436 21.5256 74.1905 21.5256C74.0373 21.5256 73.8995 21.4031 73.8995 21.25Z"
        fill="url(#paint65_radial_14427_90654)"
      />
      <path
        style={{mixBlendMode: 'screen'}}
        d="M76.5991 27.2542C77.0586 27.2542 77.4414 27.6371 77.4414 28.0965C77.4414 28.5713 77.0586 28.9541 76.5991 28.9541C76.1244 28.9541 75.7415 28.5712 75.7415 28.0965C75.7415 27.6371 76.1244 27.2542 76.5991 27.2542Z"
        fill="url(#paint66_radial_14427_90654)"
      />
      <path
        d="M75.7846 28.0967C75.7846 27.6679 76.1521 27.3004 76.5962 27.3004C77.025 27.3004 77.3926 27.6679 77.3926 28.0967C77.3926 28.5408 77.025 28.8931 76.5962 28.8931C76.1521 28.8931 75.7846 28.5408 75.7846 28.0967Z"
        fill="url(#paint67_radial_14427_90654)"
      />
      <path
        style={{mixBlendMode: 'screen'}}
        opacity="0.5"
        d="M76.0366 28.0967C76.0366 27.7597 76.3122 27.4841 76.6492 27.4841C76.9861 27.4841 77.2617 27.7597 77.2617 28.0967C77.2617 28.4336 76.9861 28.7092 76.6492 28.7092C76.3122 28.7092 76.0366 28.4336 76.0366 28.0967Z"
        fill="url(#paint68_radial_14427_90654)"
      />
      <path
        style={{mixBlendMode: 'screen'}}
        d="M76.5121 28.4029C76.5121 28.2345 76.6499 28.112 76.8031 28.112C76.9715 28.112 77.1094 28.2345 77.1094 28.4029C77.1094 28.5714 76.9715 28.7092 76.8031 28.7092C76.6499 28.7092 76.5121 28.5714 76.5121 28.4029Z"
        fill="url(#paint69_radial_14427_90654)"
      />
      <path
        style={{mixBlendMode: 'screen'}}
        d="M47.9017 5.76844C48.0854 5.76844 48.2539 5.92159 48.2539 6.12068C48.2539 6.30445 48.0854 6.4729 47.9017 6.4729C47.7026 6.4729 47.5495 6.30445 47.5495 6.12068C47.5495 5.92159 47.7026 5.76844 47.9017 5.76844Z"
        fill="url(#paint70_radial_14427_90654)"
      />
      <path
        d="M47.5612 6.12054C47.5612 5.93677 47.7144 5.78363 47.8981 5.78363C48.0819 5.78363 48.2197 5.93677 48.2197 6.12054C48.2197 6.30431 48.0819 6.44214 47.8981 6.44214C47.7144 6.44214 47.5612 6.30431 47.5612 6.12054Z"
        fill="url(#paint71_radial_14427_90654)"
      />
      <path
        style={{mixBlendMode: 'screen'}}
        opacity="0.5"
        d="M47.6724 6.12058C47.6724 5.98275 47.7796 5.86023 47.9174 5.86023C48.0552 5.86023 48.1777 5.98275 48.1777 6.12058C48.1777 6.2584 48.0552 6.3656 47.9174 6.3656C47.7796 6.3656 47.6724 6.2584 47.6724 6.12058Z"
        fill="url(#paint72_radial_14427_90654)"
      />
      <path
        style={{mixBlendMode: 'screen'}}
        d="M47.8549 6.24309C47.8549 6.18183 47.9161 6.12058 47.9774 6.12058C48.054 6.12058 48.1152 6.18183 48.1152 6.24309C48.1152 6.31966 48.054 6.3656 47.9774 6.3656C47.9161 6.3656 47.8549 6.31966 47.8549 6.24309Z"
        fill="url(#paint73_radial_14427_90654)"
      />
      <path
        style={{mixBlendMode: 'screen'}}
        d="M57.4163 9.13673C57.6001 9.13673 57.7686 9.28988 57.7686 9.48896C57.7686 9.67273 57.6001 9.84119 57.4163 9.84119C57.2172 9.84119 57.0641 9.67273 57.0641 9.48896C57.0641 9.28988 57.2172 9.13673 57.4163 9.13673Z"
        fill="url(#paint74_radial_14427_90654)"
      />
      <path
        d="M57.0759 9.48883C57.0759 9.30506 57.229 9.15192 57.4128 9.15192C57.5965 9.15192 57.7344 9.30506 57.7344 9.48883C57.7344 9.65729 57.5965 9.81042 57.4128 9.81042C57.229 9.81042 57.0759 9.65729 57.0759 9.48883Z"
        fill="url(#paint75_radial_14427_90654)"
      />
      <path
        style={{mixBlendMode: 'screen'}}
        opacity="0.5"
        d="M57.187 9.47354C57.187 9.33572 57.2942 9.22852 57.432 9.22852C57.5699 9.22852 57.6924 9.33572 57.6924 9.47354C57.6924 9.62669 57.5699 9.73389 57.432 9.73389C57.2942 9.73389 57.187 9.62669 57.187 9.47354Z"
        fill="url(#paint76_radial_14427_90654)"
      />
      <path
        style={{mixBlendMode: 'screen'}}
        d="M57.3695 9.61137C57.3695 9.5348 57.4308 9.48886 57.5074 9.48886C57.5686 9.48886 57.6299 9.5348 57.6299 9.61137C57.6299 9.67263 57.5686 9.73389 57.5074 9.73389C57.4308 9.73389 57.3695 9.67263 57.3695 9.61137Z"
        fill="url(#paint77_radial_14427_90654)"
      />
      <defs>
        <radialGradient
          id="paint0_radial_14427_90654"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(43.4923 43.9923) rotate(-180) scale(44.9778)"
        >
          <stop offset="0.7" stopColor="#FEFEFE" stopOpacity="0" />
          <stop offset="1" stopColor="#FEFEFE" />
        </radialGradient>
        <linearGradient
          id="paint1_linear_14427_90654"
          x1="31.5655"
          y1="-52.2406"
          x2="135.697"
          y2="51.8906"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FEFEFE" stopOpacity="0" />
          <stop offset="1" stopColor="#FEFEFE" />
        </linearGradient>
        <radialGradient
          id="paint2_radial_14427_90654"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(27.8278 42.9354) rotate(-180) scale(53.5232)"
        >
          <stop offset="0.3" stopColor="#F19A19" />
          <stop offset="1" stopColor="#B45739" />
        </radialGradient>
        <radialGradient
          id="paint3_radial_14427_90654"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(115.713 78.3419) rotate(-180) scale(83.3246 83.3246)"
        >
          <stop stopColor="#FEFEFE" />
          <stop offset="1" stopColor="#0A0B0B" />
        </radialGradient>
        <radialGradient
          id="paint4_radial_14427_90654"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(115.715 78.3417) rotate(-180) scale(83.3246 83.3246)"
        >
          <stop stopColor="#FEFEFE" />
          <stop offset="1" stopColor="#0A0B0B" />
        </radialGradient>
        <radialGradient
          id="paint5_radial_14427_90654"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(43.2969 43.4903) rotate(-180) scale(41.3953)"
        >
          <stop offset="0.5" stopColor="#D2D3D4" />
          <stop offset="0.7" stopColor="#FEFEFE" />
          <stop offset="0.9" stopColor="#FEFEFE" />
          <stop offset="1" stopColor="#FEFEFE" />
        </radialGradient>
        <radialGradient
          id="paint6_radial_14427_90654"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(61.4545 15.0944) rotate(-180) scale(5.83471)"
        >
          <stop stopColor="#0A0B0B" />
          <stop offset="1" stopColor="#FEFEFE" />
        </radialGradient>
        <radialGradient
          id="paint7_radial_14427_90654"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(64.4127 18.2037) rotate(-180) scale(4.59435 4.59435)"
        >
          <stop offset="0.3" stopColor="#F19A19" />
          <stop offset="1" stopColor="#B45739" />
        </radialGradient>
        <radialGradient
          id="paint8_radial_14427_90654"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(65.8524 22.1694) rotate(-180) scale(5.31403 5.31402)"
        >
          <stop stopColor="#FEFEFE" />
          <stop offset="1" stopColor="#0A0B0B" />
        </radialGradient>
        <radialGradient
          id="paint9_radial_14427_90654"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(66.8628 19.5813) rotate(-180) scale(0.980109 0.980107)"
        >
          <stop stopColor="#FEFEFE" />
          <stop offset="1" stopColor="#0A0B0B" />
        </radialGradient>
        <radialGradient
          id="paint10_radial_14427_90654"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(67.8104 67.3463) rotate(-180) scale(3.53758)"
        >
          <stop stopColor="#0A0B0B" />
          <stop offset="1" stopColor="#FEFEFE" />
        </radialGradient>
        <radialGradient
          id="paint11_radial_14427_90654"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(69.6113 69.2356) rotate(-180) scale(2.79304)"
        >
          <stop offset="0.3" stopColor="#F19A19" />
          <stop offset="1" stopColor="#B45739" />
        </radialGradient>
        <radialGradient
          id="paint12_radial_14427_90654"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(70.4755 71.6496) rotate(-180) scale(3.2313)"
        >
          <stop stopColor="#FEFEFE" />
          <stop offset="1" stopColor="#0A0B0B" />
        </radialGradient>
        <radialGradient
          id="paint13_radial_14427_90654"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(71.0839 70.0722) rotate(-180) scale(0.597254)"
        >
          <stop stopColor="#FEFEFE" />
          <stop offset="1" stopColor="#0A0B0B" />
        </radialGradient>
        <radialGradient
          id="paint14_radial_14427_90654"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(57.7147 13.8694) rotate(-180) scale(2.30729)"
        >
          <stop offset="0.3" stopColor="#F19A19" />
          <stop offset="1" stopColor="#B45739" />
        </radialGradient>
        <radialGradient
          id="paint15_radial_14427_90654"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(57.7645 13.8721) rotate(-180) scale(2.1555 2.16562)"
        >
          <stop offset="0.3" stopColor="#F19A19" />
          <stop offset="1" stopColor="#B45739" />
        </radialGradient>
        <radialGradient
          id="paint16_radial_14427_90654"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(58.4362 15.7377) rotate(-180) scale(2.49621 2.49622)"
        >
          <stop stopColor="#FEFEFE" />
          <stop offset="1" stopColor="#0A0B0B" />
        </radialGradient>
        <radialGradient
          id="paint17_radial_14427_90654"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(58.9057 14.5279) rotate(-180) scale(0.459426 0.459428)"
        >
          <stop stopColor="#FEFEFE" />
          <stop offset="1" stopColor="#0A0B0B" />
        </radialGradient>
        <radialGradient
          id="paint18_radial_14427_90654"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(79.9417 36.5492) rotate(-180) scale(2.22056 2.22056)"
        >
          <stop stopColor="#0A0B0B" />
          <stop offset="1" stopColor="#FEFEFE" />
        </radialGradient>
        <radialGradient
          id="paint19_radial_14427_90654"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(81.0804 37.7321) rotate(-180) scale(1.76083 1.75071)"
        >
          <stop offset="0.3" stopColor="#F19A19" />
          <stop offset="1" stopColor="#B45739" />
        </radialGradient>
        <radialGradient
          id="paint20_radial_14427_90654"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(81.6295 39.2443) rotate(-180) scale(2.03679 2.03679)"
        >
          <stop stopColor="#FEFEFE" />
          <stop offset="1" stopColor="#0A0B0B" />
        </radialGradient>
        <radialGradient
          id="paint21_radial_14427_90654"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(82.0083 38.2642) rotate(-180) scale(0.382856)"
        >
          <stop stopColor="#FEFEFE" />
          <stop offset="1" stopColor="#0A0B0B" />
        </radialGradient>
        <radialGradient
          id="paint22_radial_14427_90654"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(66.5171 72.5984) rotate(-180) scale(1.36297 1.36296)"
        >
          <stop stopColor="#0A0B0B" />
          <stop offset="1" stopColor="#FEFEFE" />
        </radialGradient>
        <radialGradient
          id="paint23_radial_14427_90654"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(67.2109 73.3349) rotate(-180) scale(1.08281 1.08281)"
        >
          <stop offset="0.3" stopColor="#F19A19" />
          <stop offset="1" stopColor="#B45739" />
        </radialGradient>
        <radialGradient
          id="paint24_radial_14427_90654"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(67.541 74.2678) rotate(-180) scale(1.25576 1.25577)"
        >
          <stop stopColor="#FEFEFE" />
          <stop offset="1" stopColor="#0A0B0B" />
        </radialGradient>
        <radialGradient
          id="paint25_radial_14427_90654"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(67.7868 73.6552) rotate(-180) scale(0.229713)"
        >
          <stop stopColor="#FEFEFE" />
          <stop offset="1" stopColor="#0A0B0B" />
        </radialGradient>
        <radialGradient
          id="paint26_radial_14427_90654"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(54.9676 75.6927) rotate(-180) scale(2.30729)"
        >
          <stop offset="0.3" stopColor="#F19A19" />
          <stop offset="1" stopColor="#B45739" />
        </radialGradient>
        <radialGradient
          id="paint27_radial_14427_90654"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(55.0068 75.6881) rotate(-180) scale(2.16562 2.1555)"
        >
          <stop offset="0.3" stopColor="#F19A19" />
          <stop offset="1" stopColor="#B45739" />
        </radialGradient>
        <radialGradient
          id="paint28_radial_14427_90654"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(55.6908 77.5609) rotate(-180) scale(2.49622)"
        >
          <stop stopColor="#FEFEFE" />
          <stop offset="1" stopColor="#0A0B0B" />
        </radialGradient>
        <radialGradient
          id="paint29_radial_14427_90654"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(56.1587 76.3511) rotate(-180) scale(0.459425 0.459427)"
        >
          <stop stopColor="#FEFEFE" />
          <stop offset="1" stopColor="#0A0B0B" />
        </radialGradient>
        <radialGradient
          id="paint30_radial_14427_90654"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(77.7738 31.2203) rotate(-180) scale(2.20525 2.20524)"
        >
          <stop stopColor="#0A0B0B" />
          <stop offset="1" stopColor="#FEFEFE" />
        </radialGradient>
        <radialGradient
          id="paint31_radial_14427_90654"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(78.8986 32.3883) rotate(-180) scale(1.73047 1.73047)"
        >
          <stop offset="0.3" stopColor="#F19A19" />
          <stop offset="1" stopColor="#B45739" />
        </radialGradient>
        <radialGradient
          id="paint32_radial_14427_90654"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(79.4378 33.8851) rotate(-180) scale(2.00616 2.00616)"
        >
          <stop stopColor="#FEFEFE" />
          <stop offset="1" stopColor="#0A0B0B" />
        </radialGradient>
        <radialGradient
          id="paint33_radial_14427_90654"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(79.8303 32.9203) rotate(-180) scale(0.367541)"
        >
          <stop stopColor="#FEFEFE" />
          <stop offset="1" stopColor="#0A0B0B" />
        </radialGradient>
        <radialGradient
          id="paint34_radial_14427_90654"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(72.5092 23.5323) rotate(-180) scale(1.37828)"
        >
          <stop stopColor="#0A0B0B" />
          <stop offset="1" stopColor="#FEFEFE" />
        </radialGradient>
        <radialGradient
          id="paint35_radial_14427_90654"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(73.2031 24.269) rotate(-180) scale(1.08281 1.08281)"
        >
          <stop offset="0.3" stopColor="#F19A19" />
          <stop offset="1" stopColor="#B45739" />
        </radialGradient>
        <radialGradient
          id="paint36_radial_14427_90654"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(73.5332 25.2014) rotate(-180) scale(1.25577 1.25576)"
        >
          <stop stopColor="#FEFEFE" />
          <stop offset="1" stopColor="#0A0B0B" />
        </radialGradient>
        <radialGradient
          id="paint37_radial_14427_90654"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(73.779 24.5888) rotate(-180) scale(0.229713)"
        >
          <stop stopColor="#FEFEFE" />
          <stop offset="1" stopColor="#0A0B0B" />
        </radialGradient>
        <radialGradient
          id="paint38_radial_14427_90654"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(67.9354 24.7726) rotate(-180) scale(1.56205)"
        >
          <stop stopColor="#0A0B0B" />
          <stop offset="1" stopColor="#FEFEFE" />
        </radialGradient>
        <radialGradient
          id="paint39_radial_14427_90654"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(68.7294 25.5982) rotate(-180) scale(1.2346 1.22448)"
        >
          <stop offset="0.3" stopColor="#F19A19" />
          <stop offset="1" stopColor="#B45739" />
        </radialGradient>
        <radialGradient
          id="paint40_radial_14427_90654"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(69.1158 26.6564) rotate(-180) scale(1.42422 1.42423)"
        >
          <stop stopColor="#FEFEFE" />
          <stop offset="1" stopColor="#0A0B0B" />
        </radialGradient>
        <radialGradient
          id="paint41_radial_14427_90654"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(69.3786 25.9673) rotate(-180) scale(0.260342 0.260344)"
        >
          <stop stopColor="#FEFEFE" />
          <stop offset="1" stopColor="#0A0B0B" />
        </radialGradient>
        <radialGradient
          id="paint42_radial_14427_90654"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(51.7777 7.6976) rotate(-180) scale(1.19451)"
        >
          <stop stopColor="#0A0B0B" />
          <stop offset="1" stopColor="#FEFEFE" />
        </radialGradient>
        <radialGradient
          id="paint43_radial_14427_90654"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(52.3897 8.32997) rotate(-180) scale(0.941135 0.941132)"
        >
          <stop offset="0.3" stopColor="#F19A19" />
          <stop offset="1" stopColor="#B45739" />
        </radialGradient>
        <radialGradient
          id="paint44_radial_14427_90654"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(52.6837 9.15243) rotate(-180) scale(1.10262)"
        >
          <stop stopColor="#FEFEFE" />
          <stop offset="1" stopColor="#0A0B0B" />
        </radialGradient>
        <radialGradient
          id="paint45_radial_14427_90654"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(52.8956 8.61643) rotate(-180) scale(0.199085)"
        >
          <stop stopColor="#FEFEFE" />
          <stop offset="1" stopColor="#0A0B0B" />
        </radialGradient>
        <radialGradient
          id="paint46_radial_14427_90654"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(60.2448 73.4568) rotate(-180) scale(1.19451)"
        >
          <stop stopColor="#0A0B0B" />
          <stop offset="1" stopColor="#FEFEFE" />
        </radialGradient>
        <radialGradient
          id="paint47_radial_14427_90654"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(60.8615 74.0964) rotate(-180) scale(0.951252)"
        >
          <stop offset="0.3" stopColor="#F19A19" />
          <stop offset="1" stopColor="#B45739" />
        </radialGradient>
        <radialGradient
          id="paint48_radial_14427_90654"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(61.1508 74.9114) rotate(-180) scale(1.10262)"
        >
          <stop stopColor="#FEFEFE" />
          <stop offset="1" stopColor="#0A0B0B" />
        </radialGradient>
        <radialGradient
          id="paint49_radial_14427_90654"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(61.3575 74.3907) rotate(-180) scale(0.199085)"
        >
          <stop stopColor="#FEFEFE" />
          <stop offset="1" stopColor="#0A0B0B" />
        </radialGradient>
        <radialGradient
          id="paint50_radial_14427_90654"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(52.9599 79.7661) rotate(-180) scale(1.74582)"
        >
          <stop stopColor="#0A0B0B" />
          <stop offset="1" stopColor="#FEFEFE" />
        </radialGradient>
        <radialGradient
          id="paint51_radial_14427_90654"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(53.8358 80.6882) rotate(-180) scale(1.37628 1.37628)"
        >
          <stop offset="0.3" stopColor="#F19A19" />
          <stop offset="1" stopColor="#B45739" />
        </radialGradient>
        <radialGradient
          id="paint52_radial_14427_90654"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(54.2593 81.8795) rotate(-180) scale(1.59268 1.59268)"
        >
          <stop stopColor="#FEFEFE" />
          <stop offset="1" stopColor="#0A0B0B" />
        </radialGradient>
        <radialGradient
          id="paint53_radial_14427_90654"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(54.5687 81.0985) rotate(-180) scale(0.29097)"
        >
          <stop stopColor="#FEFEFE" />
          <stop offset="1" stopColor="#0A0B0B" />
        </radialGradient>
        <radialGradient
          id="paint54_radial_14427_90654"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(52.4387 12.047) rotate(-180) scale(1.33234 1.33234)"
        >
          <stop stopColor="#0A0B0B" />
          <stop offset="1" stopColor="#FEFEFE" />
        </radialGradient>
        <radialGradient
          id="paint55_radial_14427_90654"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(53.1063 12.7609) rotate(-180) scale(1.06257 1.05245)"
        >
          <stop offset="0.3" stopColor="#F19A19" />
          <stop offset="1" stopColor="#B45739" />
        </radialGradient>
        <radialGradient
          id="paint56_radial_14427_90654"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(53.4382 13.6705) rotate(-180) scale(1.22514 1.22513)"
        >
          <stop stopColor="#FEFEFE" />
          <stop offset="1" stopColor="#0A0B0B" />
        </radialGradient>
        <radialGradient
          id="paint57_radial_14427_90654"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(53.684 13.0732) rotate(-180) scale(0.229715 0.229711)"
        >
          <stop stopColor="#FEFEFE" />
          <stop offset="1" stopColor="#0A0B0B" />
        </radialGradient>
        <radialGradient
          id="paint58_radial_14427_90654"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(49.8606 79.0156) rotate(-180) scale(0.781025)"
        >
          <stop stopColor="#0A0B0B" />
          <stop offset="1" stopColor="#FEFEFE" />
        </radialGradient>
        <radialGradient
          id="paint59_radial_14427_90654"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(50.247 79.417) rotate(-180) scale(0.617303 0.607183)"
        >
          <stop offset="0.3" stopColor="#F19A19" />
          <stop offset="1" stopColor="#B45739" />
        </radialGradient>
        <radialGradient
          id="paint60_radial_14427_90654"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(50.4469 79.9497) rotate(-180) scale(0.70445 0.704454)"
        >
          <stop stopColor="#FEFEFE" />
          <stop offset="1" stopColor="#0A0B0B" />
        </radialGradient>
        <radialGradient
          id="paint61_radial_14427_90654"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(50.5783 79.6128) rotate(-180) scale(0.137827)"
        >
          <stop stopColor="#FEFEFE" />
          <stop offset="1" stopColor="#0A0B0B" />
        </radialGradient>
        <radialGradient
          id="paint62_radial_14427_90654"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(73.0471 20.2549) rotate(-180) scale(1.27108 1.27108)"
        >
          <stop stopColor="#0A0B0B" />
          <stop offset="1" stopColor="#FEFEFE" />
        </radialGradient>
        <radialGradient
          id="paint63_radial_14427_90654"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(73.687 20.9316) rotate(-180) scale(1.00185 1.00185)"
        >
          <stop offset="0.3" stopColor="#F19A19" />
          <stop offset="1" stopColor="#B45739" />
        </radialGradient>
        <radialGradient
          id="paint64_radial_14427_90654"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(73.9991 21.8013) rotate(-180) scale(1.14857)"
        >
          <stop stopColor="#FEFEFE" />
          <stop offset="1" stopColor="#0A0B0B" />
        </radialGradient>
        <radialGradient
          id="paint65_radial_14427_90654"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(74.2211 21.2347) rotate(-180) scale(0.214398 0.2144)"
        >
          <stop stopColor="#FEFEFE" />
          <stop offset="1" stopColor="#0A0B0B" />
        </radialGradient>
        <radialGradient
          id="paint66_radial_14427_90654"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(75.5884 27.3614) rotate(-180) scale(1.33233 1.33233)"
        >
          <stop stopColor="#0A0B0B" />
          <stop offset="1" stopColor="#FEFEFE" />
        </radialGradient>
        <radialGradient
          id="paint67_radial_14427_90654"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(76.2713 28.0758) rotate(-180) scale(1.06257 1.05245)"
        >
          <stop offset="0.3" stopColor="#F19A19" />
          <stop offset="1" stopColor="#B45739" />
        </radialGradient>
        <radialGradient
          id="paint68_radial_14427_90654"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(76.6032 28.9849) rotate(-180) scale(1.22514)"
        >
          <stop stopColor="#FEFEFE" />
          <stop offset="1" stopColor="#0A0B0B" />
        </radialGradient>
        <radialGradient
          id="paint69_radial_14427_90654"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(76.8337 28.4029) rotate(-180) scale(0.229713 0.229715)"
        >
          <stop stopColor="#FEFEFE" />
          <stop offset="1" stopColor="#0A0B0B" />
        </radialGradient>
        <radialGradient
          id="paint70_radial_14427_90654"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(47.4882 5.81438) rotate(-180) scale(0.551312 0.551316)"
        >
          <stop stopColor="#0A0B0B" />
          <stop offset="1" stopColor="#FEFEFE" />
        </radialGradient>
        <radialGradient
          id="paint71_radial_14427_90654"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(47.7606 6.10423) rotate(-180) scale(0.435146)"
        >
          <stop offset="0.3" stopColor="#F19A19" />
          <stop offset="1" stopColor="#B45739" />
        </radialGradient>
        <radialGradient
          id="paint72_radial_14427_90654"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(47.9021 6.48811) rotate(-180) scale(0.505372 0.505367)"
        >
          <stop stopColor="#FEFEFE" />
          <stop offset="1" stopColor="#0A0B0B" />
        </radialGradient>
        <radialGradient
          id="paint73_radial_14427_90654"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(47.9927 6.24309) rotate(-180) scale(0.0918859 0.0918838)"
        >
          <stop stopColor="#FEFEFE" />
          <stop offset="1" stopColor="#0A0B0B" />
        </radialGradient>
        <radialGradient
          id="paint74_radial_14427_90654"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(57.0028 9.18267) rotate(-180) scale(0.551312 0.551316)"
        >
          <stop stopColor="#0A0B0B" />
          <stop offset="1" stopColor="#FEFEFE" />
        </radialGradient>
        <radialGradient
          id="paint75_radial_14427_90654"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(57.2752 9.47252) rotate(-180) scale(0.435146)"
        >
          <stop offset="0.3" stopColor="#F19A19" />
          <stop offset="1" stopColor="#B45739" />
        </radialGradient>
        <radialGradient
          id="paint76_radial_14427_90654"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(57.4167 9.8564) rotate(-180) scale(0.505372 0.505367)"
        >
          <stop stopColor="#FEFEFE" />
          <stop offset="1" stopColor="#0A0B0B" />
        </radialGradient>
        <radialGradient
          id="paint77_radial_14427_90654"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(57.5074 9.61137) rotate(-180) scale(0.0918842)"
        >
          <stop stopColor="#FEFEFE" />
          <stop offset="1" stopColor="#0A0B0B" />
        </radialGradient>
      </defs>
    </svg>
  );
};
